import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Percent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M11.9 3.534a4.023 4.023 0 1 0-.002 8.047 4.023 4.023 0 0 0 .001-8.047ZM5.78 7.557a6.119 6.119 0 0 1 6.12-6.118 6.119 6.119 0 1 1-6.12 6.118ZM32.1 32.42a4.023 4.023 0 1 0 0 8.047 4.023 4.023 0 0 0 0-8.047Zm-6.118 4.023a6.119 6.119 0 0 1 6.119-6.118 6.119 6.119 0 1 1-6.12 6.118ZM32.874.11c.519.257.73.886.473 1.404L12.53 43.418a1.048 1.048 0 0 1-1.877-.932L31.47.582c.257-.518.886-.73 1.404-.472Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
Percent.displayName = 'Percent';
Percent.defaultProps = {
  'aria-label': 'Percent'
};
export default Percent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Percent.js
// module id = 2935
// module chunks = 11